import { css } from '@emotion/react';

export const workingHoursStyles = {
    wrapper: css({
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        marginBottom: '16px',
        marginTop: '16px',
    }),
    icon: css({
        color: '#000',
        fontSize: '24px',
    }),
    container: css({
        width: '60%',
    }),
    dayRow: css({
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: '14px',
    }),
    dayName: css({
        color: '#000',
        fontWeight: 500,
    }),
    hours: css({
        color: '#000',
        fontWeight: 500,
    }),
    closed: css({
        color: '#999',
    }),
    open24: css({
        color: '#004FC6',
        fontWeight: 500,
    }),
};
